import { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  Container,
} from "reactstrap";

const ProductFAQ = () => {
  const [open, setOpen] = useState("1");

  const toggle = (id:any) => {
    if (open !== id) {
      setOpen(id);
    }
  };

  return (
    <Container className="my-5">
      <Card className="shadow-sm border-0 rounded-4">
        <CardBody className="p-4 p-md-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold">Frequently Asked Questions</h2>
            <p className="text-muted mb-0">
              Everything you need to know before joining a group.
            </p>
          </div>

          <Accordion open={open} toggle={toggle}>
            <AccordionItem>
              <AccordionHeader targetId="1">
                Is joining the group free?
              </AccordionHeader>
              <AccordionBody accordionId="1">
                Yes. Joining a PriceWorth buying group is completely free.
              </AccordionBody>
            </AccordionItem>

            <AccordionItem>
              <AccordionHeader targetId="2">
                Am I obligated to buy?
              </AccordionHeader>
              <AccordionBody accordionId="2">
                No. Joining the group does not commit you to making a purchase.
              </AccordionBody>
            </AccordionItem>

            <AccordionItem>
              <AccordionHeader targetId="3">
                Can I leave the group?
              </AccordionHeader>
              <AccordionBody accordionId="3">
               Yes. You may leave the group at any time before completing your purchase.
              </AccordionBody>
            </AccordionItem>

            <AccordionItem>
              <AccordionHeader targetId="4">
               Will my personal details be shared?
              </AccordionHeader>
              <AccordionBody accordionId="4">
               No. Your phone number and email address remain private unless you choose to share them.
              </AccordionBody>
            </AccordionItem>

            <AccordionItem>
              <AccordionHeader targetId="5">
                Who negotiates with the sellers?
              </AccordionHeader>
              <AccordionBody accordionId="5">
                Both the PriceWorth coordinator and any interested group member can negotiate with sellers or service providers. All offers are shared transparently with the group.
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="6">
                Can different members choose different sellers?
              </AccordionHeader>
              <AccordionBody accordionId="6">
               Yes. Group members are free to purchase from whichever seller or service provider offers the best value for their specific requirements.
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </CardBody>
      </Card>
    </Container>
  );
};

export default ProductFAQ;